import transaction_error from './transaction-error.json';
import try_again from './try-again.json';

export default {
  errors: {
    ...transaction_error,
    ...try_again,
  },
};
